'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function getFormattedDate(date, culture, time) {
	var isUTC = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

	var formattedDate = null;

	if (date && culture) {
		var options = _extends({
			year: 'numeric',
			month: 'long',
			day: 'numeric'
		}, time && { hour: 'numeric', minute: 'numeric', second: 'numeric' }, isUTC && { timeZone: 'UTC' });

		formattedDate = new Date(date).toLocaleDateString(culture, options);
	}

	return formattedDate;
}

exports.default = getFormattedDate;